import React, { useEffect } from 'react';

import { DashboardButton } from './Success.styled';
import { PurchaseConfirmation } from 'screens/Book/steps/Success/PurchaseConfirmation/PurchaseConfirmation';

import { Props } from './Success.types';

export const SuccessStep = ({ purchasedProduct }: Props): JSX.Element => {
  useEffect(() => {
    localStorage.setItem('BOOKING_SUCCEEDED', 'true');
  }, []);

  return (
    <>
      <PurchaseConfirmation purchase={purchasedProduct} />
      <DashboardButton
        href="/"
        onClick={() => {
          if (localStorage.getItem('BOOKING_SUCCEEDED') !== null) {
            localStorage.removeItem('BOOKING_SUCCEEDED');
          }
        }}
      >
        Go To Dashboard
      </DashboardButton>
    </>
  );
};
